import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectAlertModalDomain = state => state.alertModalReducer || initialState;

export const getIsWindowOpenSelector = () =>
	createSelector(selectAlertModalDomain, ({ windowInfo }) => Boolean(windowInfo));

export const getWindowInfoSelector = () => createSelector(selectAlertModalDomain, ({ windowInfo }) => windowInfo);
